import makeStyles from '@material-ui/styles/makeStyles'
import { IndicadoresTipologia } from 'models/Viabilidade/IndicadoresTipologia'
import NumberFormat from 'react-number-format'
import * as S from './index.style'

const useStyles = makeStyles(() => ({
  label: {
    fontFamily: 'IBMPlexSans-Bold'
  }
}))

const IndicadoresGeraisTipologia: React.FC<{ dados: IndicadoresTipologia }> = ({ dados }) => {
  const classes = useStyles()

  return (
    <S.Wrapper>
      <S.Campos>
        <S.Label data-cy="labelTotalUnidades" className={classes.label}>
          Total de Unidades
        </S.Label>
        <S.Valor color="secondary" data-cy="valorTotalUnidades">
          <NumberFormat
            value={dados.totalUnidades}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
          />
        </S.Valor>
      </S.Campos>
      <S.Campos>
        <S.Label data-cy="labelPrecoMedioCasasUnid" className={classes.label}>
          Preço Médio Casas (R$/unid)
        </S.Label>
        <S.Valor color="secondary" data-cy="valorPrecoMedioCasasUnid">
          <NumberFormat
            value={dados.precoMedioCasasUnidade}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </S.Valor>
      </S.Campos>
      <S.Campos>
        <S.Label data-cy="labelTotalPermutas" className={classes.label}>
          Total de Permutas
        </S.Label>
        <S.Valor color="secondary" data-cy="valorTotalPermutas">
          <NumberFormat
            value={dados.totalPermutas}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
          />
        </S.Valor>
      </S.Campos>
      <S.Campos>
        <S.Label data-cy="labelPrecoMedioCasasQuadrado" className={classes.label}>
          Preço Médio Casas (R$/m²)
        </S.Label>
        <S.Valor color="secondary" data-cy="valorPrecoMedioCasasQuadrado">
          <NumberFormat
            value={dados.precoMedioCasasMetroQuadrado}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </S.Valor>
      </S.Campos>
      <S.Campos>
        <S.Label data-cy="labelTotalUnidadesLiquidas" className={classes.label}>
          Total Unidades Líquidas
        </S.Label>
        <S.Valor color="secondary" data-cy="valorTotalUnidadesLiquidas">
          <NumberFormat
            value={dados.totalUnidadesLiquidas}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            allowEmptyFormatting={true}
            defaultValue="-"
          />
        </S.Valor>
      </S.Campos>
    </S.Wrapper>
  )
}

export default IndicadoresGeraisTipologia
